<template>
    <section class="fair-questions">
        <div class="section-head">
            <span class="kicker">{{ copy.kicker }}</span>
            <h2>{{ copy.title }}</h2>
        </div>
        <div class="fq-grid">
            <div
                v-for="(item, index) in copy.items"
                v-bind:key="index"
                class="fq"
                data-aos="fade-up"
                :data-aos-delay="index * 80"
            >
                <p class="fq__q">
                    <span aria-hidden="true">?</span>
                    {{ item.q }}
                </p>
                <p class="fq__a">{{ item.a }}</p>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getHomeContent } from '@/data/home'

export default {
    name: 'FairQuestionsSection',
    computed: {
        ...mapState(useStore, ['language']),
        copy() {
            return getHomeContent(this.language).objections
        },
    },
}
</script>

<style lang="scss" scoped>
.fq-grid {
    max-width: 900px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
}

@media (max-width: $mq-medium - 1) {
    .fq-grid {
        grid-template-columns: 1fr;
    }
}

.fq {
    text-align: left;
    padding: 22px 24px;
    border-radius: 18px;
    background: var(--bzioup-color-pink-soft);
    border: 1px solid rgba(218, 138, 139, 0.25);
}

.fq__q {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin: 0 0 10px;
    font-size: 17px;
    font-weight: 700;

    span {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: var(--bzioup-color-pink);
        color: #fff;
        font-size: 14px;
        font-weight: 800;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transform: translateY(3px);
    }
}

.fq__a {
    margin: 0 0 0 34px;
    font-size: 15px;
    line-height: 1.55;
    color: var(--bzioup-color-Y);
}
</style>
